/* Grondyke · home page tabs and measured carousels.
   [data-gk-tabs]     container of [data-gk-tab][aria-controls] buttons
   [data-gk-carousel] holds [data-gk-row], [data-gk-track] > [data-gk-thumb], [data-gk-prev], [data-gk-next]
   The thumb width is the visible fraction of the row and its offset the scrolled fraction, so the
   indicator is measured rather than assumed. A tab switch resets its row to 0 and re-measures. */
(function () {
  if (window.GKHomeTabs) return;
  window.GKHomeTabs = true;

  function measure(c) {
    var row = c.querySelector('[data-gk-row]');
    var track = c.querySelector('[data-gk-track]');
    var thumb = c.querySelector('[data-gk-thumb]');
    if (!row || !track || !thumb) return;
    var w = row.scrollWidth, cw = row.clientWidth, x = row.scrollLeft;
    if (w - cw > 4) { track.classList.add('is-active'); } else { track.classList.remove('is-active'); }
    thumb.style.width = Math.max(8, (cw / w) * 100) + '%';
    thumb.style.marginLeft = (x / w) * 100 + '%';
  }

  function initCarousel(c) {
    if (c.dataset.gkReady) return;
    c.dataset.gkReady = '1';
    var row = c.querySelector('[data-gk-row]');
    if (!row) return;
    var step = parseInt(c.getAttribute('data-gk-step'), 10) || 320;
    row.addEventListener('scroll', function () { measure(c); }, { passive: true });
    var prev = c.querySelector('[data-gk-prev]');
    var next = c.querySelector('[data-gk-next]');
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: step, behavior: 'smooth' }); });
    measure(c);
  }

  function activate(tabs, btn) {
    var all = tabs.querySelectorAll('[data-gk-tab]');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      var on = b === btn;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) continue;
      if (on) {
        panel.hidden = false;
        var row = panel.querySelector('[data-gk-row]');
        if (row) row.scrollLeft = 0;
        var cs = panel.querySelectorAll('[data-gk-carousel]');
        for (var j = 0; j < cs.length; j++) { initCarousel(cs[j]); measure(cs[j]); }
        if (panel.hasAttribute('data-gk-carousel')) { initCarousel(panel); measure(panel); }
      } else {
        panel.hidden = true;
      }
    }
  }

  function initTabs(tabs) {
    if (tabs.dataset.gkReady) return;
    tabs.dataset.gkReady = '1';
    var btns = tabs.querySelectorAll('[data-gk-tab]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) { activate(tabs, e.currentTarget); });
      btns[i].addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs.querySelectorAll('[data-gk-tab]'));
        var idx = list.indexOf(e.currentTarget);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = e.key === 'ArrowRight' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
          list[n].focus();
          activate(tabs, list[n]);
        }
      });
    }
    var sel = tabs.querySelector('[data-gk-tab][aria-selected="true"]') || btns[0];
    if (sel) activate(tabs, sel);
  }

  function init(root) {
    var scope = root || document;
    var t = scope.querySelectorAll('[data-gk-tabs]');
    for (var i = 0; i < t.length; i++) initTabs(t[i]);
    var c = scope.querySelectorAll('[data-gk-carousel]');
    for (var j = 0; j < c.length; j++) initCarousel(c[j]);
  }

  function remeasure() {
    var c = document.querySelectorAll('[data-gk-carousel]');
    for (var i = 0; i < c.length; i++) measure(c[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('resize', remeasure);
  window.addEventListener('load', remeasure);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
